import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'ngx-radio',
    styleUrls: ['./radio.component.scss'],
    templateUrl: './radio.component.html',
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class RadioComponent {
  @Input() list: { value: string; display: string }[];
  @Input() value: boolean;
  @Input() disabled: boolean = false;
  @Input() controlName: string;
  @Input() inLine = false;
}
